module.exports = __webpack_public_path__ + "static/media/apartment19.e684c822.jpg";